import {
    GET_COST_CENTER,
    SET_COST_CENTER
} from "./CostCenterType"

const getCostCenter = (val : any) => ({
    type: GET_COST_CENTER,
    val
});

const setCostCenter = (assetType: any) => ({
    type: SET_COST_CENTER,
    assetType: assetType
});

export {
    getCostCenter,
    setCostCenter
}
